export default __webpack_public_path__ + "static/media/netcarbs@3x.52b6d232.jpg";